module.exports = __webpack_public_path__ + "static/screaming_devilkin-42b7c26831e0ed39784e4d6d6afe0b35.jpeg";